import styled from 'styled-components'

import media from '../../utils/media'
import bg from './bg-phones-slide.svg'

export const MobilityWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;

  ${media.lessThan('xs')`
    flex-direction: column;
    
  `}
`

export const MobilitySlide = styled.div`
  width: 50%;
  margin-right: 16px;
  background-image: url(${bg});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  ${media.lessThan('xs')`
      width: 100%;
      margin-bottom: 36px;
  `}

  .swiper-slide {
  }
`

export const MobilityCardsGroup = styled.div`
  width: 50%;
  margin-left: 16px;
  ${media.lessThan('xs')`
      width: 100%;
  `}
`

export const MobilityCardItem = styled.div`
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 32px;
  }
`

export const MobilitySlideItem = styled.div`
  width: 100%;
  height: 500px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  ${({ image }) =>
    image &&
    `
      background-image: url(${image});
  `}

  ${media.lessThan('xs')`
    height: 300px;
  `}
`
